function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154545",
    style: {
      fill: "none"
    },
    d: "M0 0h24v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.634-767.8h3.642v-10.849h-3.642a.271.271 0 0 0-.2.078.271.271 0 0 0-.078.2v10.292a.271.271 0 0 0 .078.2.271.271 0 0 0 .2.079zm5 0h3.912v-10.849h-3.912zm5.268 0h3.642a.271.271 0 0 0 .2-.078.271.271 0 0 0 .078-.2v-10.292a.271.271 0 0 0-.078-.2.271.271 0 0 0-.2-.078H111.9zm-10.266 1.356a1.578 1.578 0 0 1-1.16-.474 1.578 1.578 0 0 1-.475-1.16v-10.292a1.578 1.578 0 0 1 .475-1.16 1.578 1.578 0 0 1 1.16-.475h13.909a1.578 1.578 0 0 1 1.16.475 1.578 1.578 0 0 1 .475 1.16v10.292a1.578 1.578 0 0 1-.475 1.16 1.578 1.578 0 0 1-1.16.474z",
    transform: "translate(-97 784)",
    style: {
      fill: "#707070"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeek);
export default __webpack_public_path__ + "static/media/week.f44374f613fc8ec8240f3c941f5d9c4e.svg";
export { ForwardRef as ReactComponent };